import { Configuration } from 'pripomienky-web-ts-axios';

const ApiConfiguration = (pathPrefix = ''): Configuration => new Configuration({
  basePath: `${process.env.REACT_APP_BACKEND_REST_API}${pathPrefix}`,
});

export default ApiConfiguration;
